<div *ngIf="oauths.length > 0" class="page-container">
  <div class="page-title">OAuth Connections</div>
  <div class="data-table oauth-table">
    <div class="header">ID</div>
    <div class="header">Platform</div>
    <div class="header">Username</div>
    <div class="header">Avatar</div>
    <ng-container *ngFor="let oauth of oauths">
      <div>{{oauth.id.substring(0,8)}}</div>
      <div>{{oauth.platform}}</div>
      <div><a [routerLink]="['/agent/oauth', oauth.id]">{{oauth.username}}</a></div>
      <div>
        <img *ngIf="oauth.avatar_url" [src]="oauth.avatar_url" [alt]="oauth.username" class="avatar">
        <span *ngIf="!oauth.avatar_url">-</span>
      </div>
    </ng-container>
  </div>
</div>

<div *ngIf="oauths.length === 0" class="page-container">
  <div>Loading...</div>
</div>
